// Orders status choices, grouped per parrot-media/portal/main#290:
// everyday statuses on top, a divider before the archival statuses, then an
// unselectable "Shopify" divider grouping the Shopify-specific statuses.
// Divider entries are disabled so they can never be selected.
export const ORDER_STATUS = [
    {id: 1, name: 'Pending'},
    {id: 2, name: 'In Progress'},
    {id: 7, name: 'In Production'},
    {id: 6, name: 'Ready to Ship'},
    {id: 4, name: 'Shipped'},
    {id: 'divider_archive', name: '', divider: true, disabled: true},
    {id: 3, name: 'Cancelled'},
    {id: 5, name: 'Archived'},
    {id: 'divider_shopify', name: 'Shopify', divider: true, disabled: true},
    {id: 8, name: 'Needs Review'},
    {id: 9, name: 'Cancelled by Shopify'}
];

export const ORDER_STATUS_NO_CANCEL = [
    {id: 1, name: 'Pending'},
    {id: 2, name: 'In Progress'},
    {id: 7, name: 'In Production'},
    {id: 6, name: 'Ready to Ship'},
    {id: 4, name: 'Shipped'},
    {id: 5, name: 'Archived'}
];

// The statuses staff set by hand, for the Orders list's bulk Order Status
// action (parrot-media/portal/main#322): every status but the Shopify group,
// which the webhooks set. The API refuses the others.
export const ORDER_STATUS_MANUAL = ORDER_STATUS.filter((status) =>
    status.id !== 'divider_shopify' && status.id !== 8 && status.id !== 9
);

// Whether id is a status staff may set by hand: a manual status, not a
// divider, which the select marks disabled but whose value a click can still
// carry
export const isManualOrderStatus = (id) => ORDER_STATUS_MANUAL.some((status) => status.id === id && !status.divider);

// A status id's display name, or '' for an id not in the list
export const orderStatusName = (id) => ORDER_STATUS.find((status) => status.id === id)?.name ?? '';
